const VIETNAM_TIMEZONE = 'Asia/Ho_Chi_Minh';

function formatVietnamParts(date: Date): {
  year: string;
  month: string;
  day: string;
  hour: string;
  minute: string;
} {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: VIETNAM_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(date);

  const get = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((part) => part.type === type)?.value ?? '';

  return {
    year: get('year'),
    month: get('month'),
    day: get('day'),
    hour: get('hour'),
    minute: get('minute'),
  };
}

export function splitPublishedAt(publishedAt?: string | null): { date: string; time: string } {
  if (!publishedAt) {
    return { date: '', time: '09:00' };
  }

  const parsed = new Date(publishedAt);
  if (Number.isNaN(parsed.getTime())) {
    return { date: '', time: '09:00' };
  }

  const { year, month, day, hour, minute } = formatVietnamParts(parsed);

  return {
    date: `${year}-${month}-${day}`,
    time: `${hour}:${minute}`,
  };
}

export function combinePublishedAt(date: string, time: string): string | null {
  if (!date) return null;

  const timePart = time || '09:00';
  const [hours, minutes] = timePart.split(':');
  const safeHours = String(hours ?? '09').padStart(2, '0');
  const safeMinutes = String(minutes ?? '00').padStart(2, '0');

  // Store as Vietnam wall-clock time (UTC+7).
  return `${date}T${safeHours}:${safeMinutes}:00+07:00`;
}

function isLegacyDateOnlyPublishedAt(date: Date): boolean {
  const utc = new Date(date.getTime());
  return (
    utc.getUTCHours() === 0 &&
    utc.getUTCMinutes() === 0 &&
    utc.getUTCSeconds() === 0 &&
    utc.getUTCMilliseconds() === 0
  );
}

export function formatPublishedAtDisplay(publishedAt?: string | null): string {
  if (!publishedAt) return '';

  const parsed = new Date(publishedAt);
  if (Number.isNaN(parsed.getTime())) return publishedAt;

  const { year, month, day, hour, minute } = formatVietnamParts(parsed);
  const dateText = `${day}/${month}/${year}`;

  if (isLegacyDateOnlyPublishedAt(parsed)) {
    return dateText;
  }

  return `${dateText} - ${hour}:${minute}`;
}
